import { render, staticRenderFns } from "./Blacklist.vue?vue&type=template&id=74f649eb&scoped=true"
import script from "./Blacklist.vue?vue&type=script&lang=js"
export * from "./Blacklist.vue?vue&type=script&lang=js"
import style0 from "./Blacklist.vue?vue&type=style&index=0&id=74f649eb&prod&lang=less&scoped=true"
import style1 from "./Blacklist.vue?vue&type=style&index=1&id=74f649eb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f649eb",
  null
  
)

export default component.exports